<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">发货单列表</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :extHeight="60"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <CurSaleDeliveryDetail ref="curSaleDeliveryDetailModal" />
    </div>
</template>

<script>

import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateRender, dateTimeRender } from '@/libs/tableRowTimeRender';
import CurSaleDeliveryDetail from './curSale-delivery-detail';
import { getCurSaleDeliveryList } from '@/api/modules/curSale-management/curSale-delivery';

export default {
    name: 'CurSaleDeliveryList',
    components: {
        StandPaginationTable,
        SearchCard,
        CurSaleDeliveryDetail
    },
    data() {
        return {
            mainTable: {
                tableColumns: [
                    { title: '发货单号', key: 'curSaleDeliveryRecordCode', width: 180, align: 'center' },
                    { title: '关联销售单号', key: 'curSaleOrderRecordCode', width: 180, align: 'center' },
                    { title: '发货苗场', key: 'seedFarmName', align: 'center' },
                    { title: '转运站', key: 'distributionStationName', align: 'center' },
                    { title: '会员号', key: 'userName', align: 'center' },
                    { title: '会员名', key: 'userPersonName', align: 'center' },
                    { title: '物流公司', key: 'curSaleDeliveryRecordLogisticsCompanyName', align: 'center' },
                    { title: '支付情况', key: 'curSaleDeliveryRecordPaidStatus', align: 'center' },
                    // {
                    //     title: '质检情况', key: 'curSaleDeliveryRecordDistributionStationCheckStatus', width: 100, align: 'center',
                    //     renderHeader: (h, { column, index }) => {
                    //         return h('div',
                    //             [
                    //                 h('span', {}, column.title),
                    //                 h('icon', {
                    //                     props: {
                    //                         type: this.checkStatusOrderIcon,
                    //                         size: 16
                    //                     },
                    //                     style: {
                    //                         marginLeft: '8px'
                    //                     },
                    //                     on: {
                    //                         click: () => {
                    //                             this.onCheckStatusOrderChange();
                    //                         }
                    //                     }

                    //                 })
                    //             ]
                    //         );
                    //     }
                    // },
                    {
                        title: '发货状态', key: 'unDeliveryCount', width: 100, align: 'center',
                        renderHeader: (h, { column, index }) => {
                            return h('div',
                                [
                                    h('span', {}, column.title),
                                    h('icon', {
                                        props: {
                                            type: this.deliveryOrderIcon,
                                            size: 16
                                        },
                                        style: {
                                            marginLeft: '8px'
                                        },
                                        on: {
                                            click: () => {
                                                this.onDeliveryChange();
                                            }
                                        }

                                    })
                                ]
                            );
                        },
                        render: (h, params) => {
                            return h('span', {}, params.row.unDeliveryCount > 0 ? '未发货' : '已发货');
                        }
                    },
                    { title: '发货日期', key: 'curSaleDeliveryRecordDeliveryDate', align: 'center', render: (h, params) => dateRender(h, params.row.curSaleDeliveryRecordDeliveryDate) },
                    { title: '制单时间', key: 'curSaleDeliveryRecordCreateAt', align: 'center', width: 120, render: (h, params) => dateTimeRender(h, params.row.curSaleDeliveryRecordCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.$refs.curSaleDeliveryDetailModal.showModal(params.row.curSaleDeliveryRecordUuid);
                                        }
                                    }
                                }, '查看')]);
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '发货单号', type: 'Input', value: '', name: 'curSaleDeliveryRecordCode', sql: 'like' },
                    { label: '销售单号', type: 'Input', value: '', name: 'curSaleOrderRecordCode', sql: 'like' },
                    { label: '发货日期', type: 'Daterange', value: '', name: 'curSaleDeliveryRecordDeliveryDate', sql: 'dateBetween' },
                    { label: '发货苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '转运站', type: 'Input', value: '', name: 'distributionStationName', sql: 'like' },
                    { label: '会员信息', type: 'Input', value: '', name: 'concat(userName, userPersonName) ', sql: 'like' }
                ]
            },
            checkStatusOrder: 0,
            deliveryOrder: 0
        };
    },
    props: {
        userType: { type: String, default: '' }
    },
    mounted() {
        this.init();
    },
    computed: {
        checkStatusOrderIcon() {
            if (this.checkStatusOrder == 1) {
                return 'md-arrow-round-up';
            }
            else if (this.checkStatusOrder == 2) {
                return 'md-arrow-round-down';
            }
            else {
                return 'md-reorder';
            }
        },
        deliveryOrderIcon() {
            if (this.deliveryOrder == 1) {
                return 'md-arrow-round-up';
            }
            else if (this.deliveryOrder == 2) {
                return 'md-arrow-round-down';
            }
            else {
                return 'md-reorder';
            }
        }
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        onDeliveryChange() {
            this.deliveryOrder = (this.deliveryOrder + 1) % 3;
            this.getMainTableRecords();
        },
        onCheckStatusOrderChange() {
            this.checkStatusOrder = (this.checkStatusOrder + 1) % 3;
            this.getMainTableRecords();
        },
        setOrderCondition() {
            this.mainTable.tableSearch.order.enable = false;
            this.mainTable.tableSearch.order.conditions = [];

            if (this.checkStatusOrder == 1) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "curSaleDeliveryRecordDistributionStationCheckStatus",
                    type: "asc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }
            else if (this.checkStatusOrder == 2) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "curSaleDeliveryRecordDistributionStationCheckStatus",
                    type: "desc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }

            if (this.deliveryOrder == 1) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "unDeliveryCount",
                    type: "asc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }
            else if (this.deliveryOrder == 2) {
                this.mainTable.tableSearch.order.conditions.push({
                    name: "unDeliveryCount",
                    type: "desc"
                });
                this.mainTable.tableSearch.order.enable = true;
            }
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "userType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'userType',
                    type: 'eq',
                    value: this.userType
                });
            }
            this.setOrderCondition();
            getCurSaleDeliveryList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
